// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3sEj7{line-height:24px}", ""]);
// Exports
exports.locals = {
	"enableCountryErrorInfo": "_3sEj7"
};
module.exports = exports;
